export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s har inte valts';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s får inte vara tomt';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s är ett obligatoriskt fält';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s har inte angetts korrekt';
                break;

            case 'opt-in':
                translation = 'Kryssa i rutan för att fortsätta';
                break;

            default:
                translation = 'Det här fältet har inte fyllts i korrekt';
                break;
        }

        return translation;
    }
}
